// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/tipo-destino/list',
    name: 'tipo-destino-hotels-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/hotels/TipoDestino.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_tipo_destino_hotels',
    },
  },
]

export default formTable
